import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { GDPRBanner } from '@wkda/gdpr-banner-react';
import { GDPRCookie } from '@wkda/gdprlib';
import axios from 'axios';
import { isProduction, API_WA_KEY } from 'config';
import { getGdprPreferencesCookie, getGdprBannerContent } from '../selectors';
import { useGTM } from '../../../../modules/gtm';

const axiosInstance = axios.create({ params: { wa_key: API_WA_KEY } });
const cookieService = new Cookies();

/**
 * @param {object} props
 * @param {object} props.gdprCookieBanner
 * @param {string} props.gdprPreferences
 * @returns {JSX.Element}
 */
const GDPRBannerContainer = ({ gdprCookieBanner, gdprPreferences }) => {
  const [GTMScript, setGTMScript] = useState(null);
  const gtmService = useGTM({
    onStart(script) {
      setGTMScript(script);
    },
  });

  useEffect(() => {
    // Fires gdprlib's GET /v1/gdpr-preferences once per browser page load,
    // which is what emits the banner-landing-frontend tracking event on
    // every page, not only the homepage. Effects never run during SSR, so
    // this only ever executes client-side.
    GDPRCookie.init(
      cookieService.getAll(),
      cookieService,
      isProduction,
      axiosInstance,
    ).catch(() => undefined);
  }, []);

  return !!gdprCookieBanner && !gdprPreferences ? (
    <>
      <GDPRBanner
        content={gdprCookieBanner}
        cookieService={cookieService}
        APIService={axiosInstance}
        isProd={isProduction}
        onSubmit={() => {
          gtmService.update();
        }}
      />
      <Helmet>{GTMScript ? <script>{GTMScript}</script> : null}</Helmet>
    </>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    gdprCookieBanner: getGdprBannerContent(state),
    gdprPreferences: getGdprPreferencesCookie(state),
  };
};

GDPRBannerContainer.propTypes = {
  gdprCookieBanner: PropTypes.object,
  gdprPreferences: PropTypes.object || PropTypes.string,
};

export default connect(mapStateToProps)(GDPRBannerContainer);
